
<template>
  <button
    class="t-button u-cursor-pointer u-center t-text"
    @click="$emit('click')"
    :class="{
      'is-white': isWhite,
      'is-ghost': isGhost,
      'is-small': isSmall
    }"
  >
    <template v-if="url !== ''" >
      <a v-if="isUrlAbsolute" :href="url" target="_blank" class="u-relative t-button__inner">
        <slot/>
      </a>
      <router-link v-else :to="url" class="u-relative t-button__inner">
        <slot/>
      </router-link>
    </template>
    <router-link v-else-if="to.name" :to="to" class="u-relative t-button__inner">
      <slot/>
    </router-link>
    <span v-else class="u-relative t-button__inner" :class="{'u-flex u-center u-middle': icon}">
      <slot/>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    to: {
      type: Object,
      default: () => {return {}}
    },
    icon: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    isGhost: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isUrlAbsolute () {
      if (!this.url) {
        return true
      }
      else if (this.url.startsWith('http')) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.t-button
  position relative
  color: $colors.white
  background-color transparent
  z-index 0

  &__inner
    padding clamp(10px, 0.7em, 20px) clamp(15px, 2.5em, 40px) clamp(10px, 0.8em, 20px)
    display inline-block
  
  &.is-small
    .t-button__inner
      padding: clamp(5px, .5em, 10px) clamp(10px, 1.5em, 20px)  clamp(7px, .7em, 12px)

  &:after
    content ''
    z-index -1
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    border-radius 100px
    background-color: $colors.blue
    transition: transform .5s ease-in-out-quart

  &.is-white
    color: $colors.blue

    &:after
      background-color: $colors.white
  
  &.is-ghost.is-white
    color: $colors.white

    &:after
      border: solid 2px $colors.white

  &.is-ghost
    color: $colors.blue

    &:after
      border: solid 2px $colors.blue
      background-color: transparent
  
  &:hover
    &:after
      transform scale(1.2, 1.2)

</style>